import { atomWithStorage } from 'jotai/utils'
// 永続的なグローバルステートの定義
export const authAtom = atomWithStorage('auth', null);
// getOnInit: 初回描画時点でlocalStorageの値を同期的に読む（CLS対策 2026-09-03）。
// 既定(false)だと初回は既定値→effectで保存値に差し替わるため、ホームの「進行中の注文」や
// 各バナーが1フレーム遅れて挿入され、下のメニューが押し下げられる（レイアウトずれ）。
export const customerAtom = atomWithStorage('customer', null, undefined, { getOnInit: true });
export const activeOrdersAtom = atomWithStorage('activeOrders', [], undefined, { getOnInit: true });
